import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M2.014 4L12 13.986 21.986 4H2.014z" }),
    React.createElement("path", { d: "M2 6.814l9.293 9.293h1.414L22 6.814V18a2 2 0 01-2 2H4a2 2 0 01-2-2V6.814z" })));
export default createSvgIcon(iconPath, "Email");
//# sourceMappingURL=EmailIcon.js.map